import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { activeSnack } from './common';
import { del, get, put, post } from '../http';
import { covertToJSON } from '../../utils/stateToJson';

// --- API THUNKS START ---
export const createCountry = createAsyncThunk(
  'country/create',
  async ({ state, dispatch, handleClose, handleClear }) => {
    try {
      const URL = `/country/admin/new`;
      const response = await post(URL, state);
      if (response) {
        handleClose();
        handleClear();
        dispatch(activeSnack({ type: 'success', message: 'country created successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getAllCountry = createAsyncThunk(
  'country/list',
  async ({ page, search, dispatch, limit }) => {
    try {
      const response = await get(
        `/country/all?page=${page && page}&search=${search && search}&limit=${limit || 5}`
      );
      console.log(response);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getCountryDetails = createAsyncThunk(
  'country/single',
  async ({ countryId, dispatch }) => {
    try {
      console.log('ID:', countryId);
      const response = await get(`/country/admin/${countryId}`);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const updateCountryDetails = createAsyncThunk(
  'country/update',
  async ({ state, countryId, dispatch, handleClose, handleClear }) => {
    try {
      const URL = `/country/admin/${countryId}`;
      const response = await put(URL, state);
      if (response) {
        if (handleClose) {
          handleClose();
        }
        dispatch(activeSnack({ type: 'success', message: 'country updated Successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const deleteCountry = createAsyncThunk(
  'country/delete',
  async ({ countryId, dispatch, handleCloseDeleteDialog }) => {
    try {
      const response = await del(`/country/admin/${countryId}/`);
      if (response) {
        handleCloseDeleteDialog();
        dispatch(activeSnack({ type: 'success', message: 'country deleted Successfully' }));
        return response?._id;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getAllCountries = createAsyncThunk(
  'country/list',
  async ({ page, search, dispatch, limit }) => {
    try {
      const response = await get(
        `/country/all?page=${page && page}&search=${search && search}&limit=${limit && limit}`
      );
      console.log(response);
      if (response) {
        return {
          countries: response?.countries,
          total: response?.total,
          page: response?.page,
        };
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
// --- REDUX SLICE START ---
export const countrySlice = createSlice({
  name: 'country',
  initialState: {
    loading: false,
    error: {},
    // staff
    country: {},
    staffDropList: [],
    CountryDetails: {},
  },
  reducers: {
    clearStaffError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    // create staff details
    [createCountry.pending]: (state) => {
      state.loading = true;
    },
    [createCountry.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.country;
      const newCountrysList = jsonState?.countries;

      const modifiedCountryList = {
        ...jsonState,
        countries: Array.isArray(newCountrysList)
          ? [action.payload, ...newCountrysList]
          : [action.payload],
      };
      state.loading = false;
      state.CountryDetails = action.payload;
      state.country = modifiedCountryList;
      state.error = {};
    },
    [createCountry.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // get all country
    [getAllCountry.pending]: (state) => {
      state.loading = true;
    },
    [getAllCountry.fulfilled]: (state, action) => {
      state.loading = false;
      state.country = action.payload;
      state.error = {};
    },
    [getAllCountry.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // get single staff details
    [getCountryDetails.pending]: (state) => {
      state.loading = true;
    },
    [getCountryDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.CountryDetails = action.payload;
      state.error = {};
    },
    [getCountryDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // update staff details
    [updateCountryDetails.pending]: (state) => {
      state.loading = true;
    },
    // [updateCountryDetails.fulfilled]: (state, action) => {
    //   state.loading = false;
    //   state.CountryDetails = action.payload;
    //   state.error = {};
    // },
    [updateCountryDetails.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.country;
      const modifiedCountryList = {
        ...jsonState,
        countries: jsonState.countries?.map((i) =>
          i._id === action.payload._id ? action?.payload : i
        ),
      };

      state.loading = false;
      // state.country = modifiedCountryList;
      state.CountryDetails = action.payload;
      state.country = modifiedCountryList;
      state.error = {};
    },
    // [updateCountryDetails.fulfilled]: (state, action) => {
    //   console.log(action.payload)
    //   const jsonState = covertToJSON(state)?.country;
    //   console.log(jsonState)
    //   const modifiedCountryList = {
    //     ...jsonState,
    //     countries: jsonState.countries?.map((i) => (i._id === action.payload._id ? action?.payload : i)),
    //     // list: Array.isArray(jsonState?.list) ? [...jsonState?.list, action.payload] : [action.payload],
    //   };
    //   state.loading = false;
    //   state.CountryDetails = action.payload;
    //   state.partnerType = modifiedCountryList;
    //   state.error = {};
    // },
    [updateCountryDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [deleteCountry.pending]: (state) => {
      state.loading = true;
    },
    [deleteCountry.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.country;
      const modifiedCountryList = {
        ...jsonState,
        countries: jsonState.countries?.filter((country) => country._id !== action.payload),
      };
      state.loading = false;
      state.country = modifiedCountryList;
      state.error = {};
    },
    [deleteCountry.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearStaffError } = countrySlice.actions;

export default countrySlice.reducer;
